import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAppContext } from "../../../context/AppContext";
import { ValidateUserAccess } from "../../../network/api/ValidateUserAccess";
import Loader from "../../../components/Loader";
import { AppAnnouncementsData } from "../../../network/api/AppAnnouncementsData";

export default function LoggedInUserWrapper({ authroutes = true }) {
    const location = useLocation();
    const [loggedIn, setLoggedIn] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const {
        isLoggedIn,
        setUserAccessData,
        appData,
        setAnnouncements,
        setAreAnnouncementsLoading,
    } = useAppContext();

    useEffect(() => {
        const validateAndSetUserAccess = async () => {
            const response = await ValidateUserAccess();
            
            if (response.status === "success" && response.data) {
                setUserAccessData(response.data);
                setLoggedIn(true);
            } else {
                setLoggedIn(false);
            }

            setIsLoading(false);
        };

        validateAndSetUserAccess();
    }, [isLoggedIn, setUserAccessData]);

    useEffect(() => {
        const fetchAnnouncements = async () => {
            if (authroutes || !loggedIn || !appData?.id) {
                if (!loggedIn) {
                    setAnnouncements([]);
                }
                setAreAnnouncementsLoading(false);
                return;
            }

            setAreAnnouncementsLoading(true);

            const response = await AppAnnouncementsData({
                appId: appData.id,
                pageFilters: {
                    active_only: true,
                    limit: 50,
                    page: 1,
                },
            });

            if (response.status === "success" && response.data) {
                setAnnouncements(Array.isArray(response.data.data) ? response.data.data : []);
            } else {
                setAnnouncements([]);
            }

            setAreAnnouncementsLoading(false);
        };

        fetchAnnouncements();
    }, [
        authroutes,
        loggedIn,
        appData?.id,
        setAnnouncements,
        setAreAnnouncementsLoading,
    ]);

    if (isLoading) {
        return( <div className="app-preloader" key={location.pathname} aria-busy="true">
         <Loader />
        </div>
        );
    }

    if (authroutes) {
        return loggedIn
            ? <Navigate to="/home"  state={{ from: location }} replace key={`logged-in-user-home-${location.pathname}`} />
            : <Outlet key={`logged-in-user-outlet-other-${location.pathname}`} />;
    } else {
        return loggedIn
            ? <Outlet key={`logged-in-user-outlet-${location.pathname}`} />
            : <Navigate key={`logged-in-user-login-${location.pathname}`} to="/login"  state={{ from: location }} replace />;
    }
}
